import styles from '../../index.module.less';
import TreeSearchTable from '../skuTreeSearchTable';
import { useState } from 'react'
export default function ProductManage() {
  return (
    <div className={styles.baseBox}>
      {/* 表格 */}
      <TreeSearchTable />
    </div>
  )
}
